export const URL = `http://localhost:5000`;
// export const URL = `http://3.108.236.179`

export const pageListClass = "px-4 py-2 leading-tight text-gray-500  border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
